import React, {Component} from 'react';
import {
    Button,
    Col,
    Form,
    FormGroup,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    UncontrolledTooltip
} from "reactstrap";
import {request} from "../../../helper/APIUtils";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import {isValidVergiKimlik} from "../../../helper/VergiKimlikNoValidator";
import {isValidTckn} from "../../../helper/TCKimlikNoValidator";
import {validateComponent, validateField} from "../../../common/validation";
import Alert from "react-s-alert";

class CustomerChangeVknTcknModal extends Component{
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            newVknTckn:"",
            caseName:"",
            editCustomer:{
                oldVknTckn:"",
                newVknTckn:"",
                givenName:"",
                middleName:"",
                familyName:"",
                formattedName:""
            },
        };

        this.closeModal = this.closeModal.bind(this);
        this.showCase = this.showCase.bind(this);
        this.onSave = this.onSave.bind(this);
    }


    clearEditCustomer(){
        let self = this;
        let editCustomer={
            oldVknTckn:"",
            newVknTckn:"",
            givenName:"",
            familyName:"",
            formattedName:""
        }
        self.setState({editCustomer});
    }

    closeModal(){
        let self = this;
        self.props.toogle();
        self.clearEditCustomer()
        self.setState({error:{},caseName:""});
    }

    onSave(){
        this.props.onUpdateVknTckn(this.state.editCustomer);
        this.closeModal();
    }

    onValueChange(e){
        let self = this;
        let editCustomer = self.state.editCustomer;
        const value = e.target.value;
        const name = e.target.name;
        if(name === "newVknTckn"){
            let pattern = /^[0-9]+$/;
            if(value.length === 0 || pattern.test(value)){
                editCustomer[name] = value;
                self.switchCase(value.length);
            }
        }
        else{
            editCustomer[name] = value;
        }

        self.setState({editCustomer});
    }

    switchCase(length){
        if(length===10){
            this.setState({caseName:"vkn"});
        }
        else if(length === 11){
            this.setState({caseName:"tckn"});
        }
    }

    showCase(caseName){
        if(caseName === "tckn"){
            return(
                <div>
                    <div className="row ">
                        <Col>
                            <FormGroup  row className="col-12 mr-lg-3" >
                                <Col sm={6}>
                                    <Label className="col-form-label">Adı: </Label>
                                </Col>

                                <Col sm={6} className={this.validateClass('tGivenName')}>
                                    <input className="form-control"
                                           id="tGivenName"
                                           type="text"
                                           name="givenName"
                                           value={this.state.editCustomer.givenName}
                                           data-vlength="1,255"
                                           onBlur={(e)=>this.onStringBlur(e)}
                                           onChange={(e)=>this.onValueChange(e)}/>
                                    {this.validateMessage('tGivenName') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tGivenName" delay={0}>
                                        {this.validateMessage("tGivenName")}
                                    </UncontrolledTooltip>}
                                </Col>
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup row className="col-12">
                                <Col>
                                    <Label>Soyadı: </Label>
                                </Col>

                                <Col className={this.validateClass('tFamilyName')}>
                                    <input className="form-control"
                                           id="tFamilyName"
                                           name="familyName"
                                           type="text"
                                           data-vlength="1,255"
                                           value={this.state.editCustomer.familyName}
                                           onBlur={(e)=>this.onStringBlur(e)}
                                           onChange={(e)=>this.onValueChange(e)}
                                    />
                                    {this.validateMessage('tFamilyName') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tFamilyName" delay={0}>
                                        {this.validateMessage("tFamilyName")}
                                    </UncontrolledTooltip>}
                                </Col>
                            </FormGroup>
                        </Col>
                    </div>
                    <div className="row">
                        <Col>
                            <FormGroup row className="col-12">
                                <Col>
                                    <Label>Orta Adı: </Label>
                                </Col>

                                <Col className={this.validateClass('tMiddleName')}>
                                    <input className="form-control"
                                           id="tMiddleName"
                                           name="middleName"
                                           type="text"
                                           data-vlength="0,255"
                                           value={this.state.editCustomer.middleName}
                                           onBlur={(e)=>this.onStringBlur(e)}
                                           onChange={(e)=>this.onValueChange(e)}
                                    />
                                    {this.validateMessage('tMiddleName') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tMiddleName" delay={0}>
                                        {this.validateMessage("tMiddleName")}
                                    </UncontrolledTooltip>}
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col></Col>
                    </div>
                </div>
            )
        }
        else if(caseName==="vkn"){
            return(
                <div className="row">
                    <Col>
                        <FormGroup row className="col-12 mr-lg-3">
                            <Col lg={6}>
                                <Label className="col-form-label">Unvanı: </Label>
                            </Col>

                            <Col lg={6} className={this.validateClass('tFormattedName')}>
                                <input className="form-control"
                                       id="tFormattedName"
                                       name="formattedName"
                                       type="text"
                                       data-vlength="1,255"
                                       value={this.state.editCustomer.formattedName}
                                       onBlur={(e)=>this.onStringBlur(e)}
                                       onChange={(e)=> this.onValueChange(e)}/>
                                {this.validateMessage('tFormattedName') !== "" &&
                                <UncontrolledTooltip placement="right" target="tFormattedName" delay={0}>
                                    {this.validateMessage("tFormattedName")}
                                </UncontrolledTooltip>}
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col lg={6}>
                        <Col>
                            <Label></Label>

                        </Col>
                        <Col></Col>
                    </Col>
                </div>
            )
        }
    }


    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength && e.target.dataset.vlength;
        let value = e.target.value;

        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error:error});
    }

    errorForVknTckn() {
        let tVknTckn = {
            valid: false,
            message: "Girdiğiniz VKN/TCKN* Geçersiz!"
        };
        let error = deepCopyObject(this.state.error);
        error.tVknTckn = tVknTckn;
        this.setState({
            error
        });
        Alert.error('Girdiğiniz VKN/TCKN* Geçersiz!', {
            html: true,
            position: 'top-right',
            effect: 'stackslide',
            timeout: 5000
        })
    }

    onStringBlur(e){
        this.validateField(e);
    }

    onVknBlur(e) {

        let error = deepCopyObject(this.state.error);
        this.validateField(e);
        if (!!this.state.editCustomer.newVknTckn) {
            this.checkIfVknExists(this.state.editCustomer.newVknTckn);
        }

        if (this.state.editCustomer.newVknTckn != null && this.state.editCustomer.newVknTckn.length === 10) {

            if (!isValidVergiKimlik(this.state.editCustomer.newVknTckn)) {
                this.errorForVknTckn();
            } else {
                if (error.tVknTckn) {
                    delete error.tVknTckn;
                    this.setState({error});
                }
            }

        } else if (this.state.editCustomer.newVknTckn != null && this.state.editCustomer.newVknTckn.length === 11) {

            if (!isValidTckn(this.state.editCustomer.newVknTckn)) {
                this.errorForVknTckn();
            } else {
                if (error.tVknTckn) {
                    delete error.tVknTckn;
                    this.setState({error});
                }
            }

        } else if (this.state.editCustomer.newVknTckn != null
            && this.state.editCustomer.newVknTckn.length < 10
            && this.state.editCustomer.newVknTckn.length > 0) {
            this.errorForVknTckn();
        }

        if (e.target.value.length === 10) {
            if (error.tGivenName) {
                delete error.tGivenName;
                this.setState({error})
            }
            if (error.tFamilyName) {
                delete error.tFamilyName;
                this.setState({error})
            }
        }
        if (e.target.value.length === 11) {
            if (error.tFormattedName) {
                delete error.tFormattedName;
                this.setState({error})
            }
        }
    }


    checkIfVknExists(value) {
        let self = this;
        const data = value;
        let params = {
            url: `/customer/findByVknTckn`,
            data: data,
            method: 'post'
        };
        request(params).then(function (response) {
            if (response.data) {
                let tVknTckn = {
                    valid: false,
                    message: "Bu Vkn/Tckn'li Müşteri Zaten Mevcut"
                };
                let error = deepCopyObject(self.state.error);
                error.tVknTckn = tVknTckn;
                self.setState({
                    error
                });
                Alert.error('Bu Vkn/Tckn\'li Müşteri Zaten Mevcut', {
                    html: true,
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                })
            }
        })
            .catch(function (error) {
                showAxiosError(error);
            });
    }

    isDisabledUpdateButton(){
        let self = this;
        let error = self.state.error;
        let keys = Object.keys(error);

        if(self.state.caseName==="tckn"
            && (self.state.editCustomer.newVknTckn.length === 0
            || self.state.editCustomer.givenName.length === 0
            || self.state.editCustomer.familyName.length === 0)){
            return true;
        }
        else if(self.state.caseName==="vkn"
            &&( self.state.editCustomer.newVknTckn.length === 0
            || self.state.editCustomer.formattedName.length === 0))
            return true;
        else if(self.state.caseName ==="")
            return true;

        if(keys.length === 0)
            return false;

       if(keys.filter(item => (error[item] !== undefined && !error[item].valid)).length>0 )
           return true;
       else
           return false;
    }


    render(){
            return(
                <div>
                    <Modal isOpen={this.props.isOpen} size='lg'>
                        <ModalHeader toggle={this.closeModal}>
                            Vkn/Tckn Değiştir
                        </ModalHeader>
                        <ModalBody>

                            <Form className="  bg-light" >
                                <div className="row">
                                    <Col>
                                        <FormGroup row className="col-12 mr-lg-3">
                                            <Col sm={6}>
                                                <Label>Eski VKN/TCKN:</Label>
                                            </Col>
                                            <Col sm={6}>
                                                {this.props.customer &&
                                                <input className="form-control"
                                                       type="text"
                                                       value={this.props.customer.vknTckn}
                                                       maxLength={11}
                                                       readOnly/>
                                                }
                                            </Col>

                                        </FormGroup>
                                    </Col>

                                    <Col>
                                        <FormGroup row className="col-12">
                                            <Col sm={6} >
                                                <Label>Yeni VKN/TCKN: </Label>
                                            </Col>
                                            <Col sm={6} className={this.validateClass('tVknTckn')}>
                                                <input className="form-control"
                                                       id="tVknTckn"
                                                       type="text"
                                                       name="newVknTckn"
                                                       value={this.state.editCustomer.newVknTckn}
                                                       onBlur={(e)=> this.onVknBlur(e)}
                                                       maxLength={11}
                                                       data-vlength="10,11"
                                                       data-vdata="identifier"
                                                       onChange={(e)=>this.onValueChange(e)} />
                                                {this.validateMessage('tVknTckn') !== "" &&
                                                <UncontrolledTooltip placement="right" target="tVknTckn" delay={0}>
                                                    {this.validateMessage("tVknTckn")}
                                                </UncontrolledTooltip>}
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </div>
                                {this.showCase(this.state.caseName)}
                            </Form>



                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={()=>this.closeModal()}>İptal</Button>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{
                                        background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                        float: 'right',
                                        paddingRight:'35px'
                                    }}
                                    rel="tooltip" className="TekBtn kaydet btn-icon"
                                    title='Kaydet'
                                    disabled={this.isDisabledUpdateButton()}
                                    onClick={() => this.onSave()}>Kaydet
                            </button>
                        </ModalFooter>
                    </Modal>
                </div>
            );
        }
}

export default CustomerChangeVknTcknModal;